import { getConfigOrNull } from './config-registry';
import type { TemplateBuilderUser } from './template-builder-config';

/**
 * Returns the host-supplied user from the active config, or `null` when no
 * config is installed or the host didn't supply one. Config-backed replacement
 * for the `window.AccessEvo` `useUser` on the WFM/library path: the value is
 * synchronous (the host passes it via `TemplateBuilderConfig`), so consumers
 * re-render with the provider subtree when it changes — no effect/event needed.
 */
export function useUser(): TemplateBuilderUser | null {
  return getConfigOrNull()?.user ?? null;
}
